<template>
  <div class="pipe-flow-analysis bg-transparent rounded-2px z-99 w-full h-full pt-10px">
    <el-row :gutter="10" class="pr-5px">
      <el-col :span="12">
        <el-select
          v-model="searchData.deviceName"
          size="small"
          class="ml-5px"
          ref="fatherNode"
          popper-class="visualization-select-popper"
          placeholder="请选择装置"
          filterable
        >
          <el-input
            placeholder="此处输入关键词搜索查询"
            prefix-icon="el-icon-search"
            v-model="treeFilterKey"
            size="mini"
            clearable
          ></el-input>
          <el-option
            hidden
            key="id"
            :label="searchData.deviceName"
            :value="searchData.deviceName"
          ></el-option>
          <el-tree
            v-loading="deviceTreeLoading"
            ref="smallTreeDom"
            :data="treeData"
            empty-text="暂无数据"
            highlight-current
            :props="defaultTreeProps"
            :expand-on-click-node="false"
            :default-expand-all="false"
            :filter-node-method="filterTreeNode"
            @node-click="treeSelect"
            class="device-tree text-14px"
          >
          </el-tree>
        </el-select>
      </el-col>
      <el-col :span="12">
        <el-input
          size="small"
          v-model="searchData.tagCode"
          placeholder="请输入管道编码"
          clearable
          class="ml-5px"
        ></el-input>
      </el-col>
    </el-row>
    <el-row :gutter="10" class="pr-5px mt-10px">
      <el-col :span="12">
        <el-select
          size="small"
          class="ml-5px"
          popper-class="visualization-select-popper"
          v-model="searchData.medium"
          placeholder="请选择介质"
          filterable
          clearable
        >
          <el-option
            v-for="item in mediumList"
            :label="item.value"
            :value="item.key"
            :key="item.key"
          />
        </el-select>
      </el-col>
      <el-col :span="12" class="search-wrap h-36px leading-36px">
        <el-button @click="searchHandler" size="small" type="primary">搜索</el-button>
        <span class="whitespace-nowrap text-[#fff] ml-5px text-14px">流向动画</span>
        <el-switch
          class="ml-5px"
          v-model="allFlowStatus"
          :disabled="allFlowDisabled || isRootModel"
          @change="changeAllStatus"
          inactive-text-color="#fff"
          active-color="#45f2eb"
        ></el-switch>
      </el-col>
    </el-row>
    <div class="flex items-center">
      <span class="pr-20px text-[#fff] text-14px">透明度</span>
      <el-slider
        class="flex-1"
        v-model="transparency"
        @change="transChange"
        :format-tooltip="tooltipFormat"
      ></el-slider>
    </div>
    <el-table
      ref="markerTable"
      :data="tableData"
      :row-key="(row) => row.tagId"
      class="markerTable"
      height="calc(100% - 158px)"
      :cell-style="{ 'text-align': 'center' }"
      :header-cell-style="{ 'text-align': 'center' }"
      :highlight-current-row="true"
      @selection-change="handleSelectionChange"
      @row-click="moveToPipe"
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column show-overflow-tooltip prop="deviceName" label="装置名称"></el-table-column>
      <el-table-column show-overflow-tooltip prop="tagCode" label="管道名称"></el-table-column>
      <el-table-column show-overflow-tooltip prop="medium" label="介质">
        <template slot-scope="{ row }">
          <span>{{ getMediumName(row.medium) }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      small
      background
      @current-change="getTableData"
      :current-page.sync="page.pageNo"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
      :pager-count="5"
      class="flex justify-end mt-10px"
    ></el-pagination>
  </div>
</template>

<script>
import { isEmpty, findIndex, filter, map, forEach } from 'lodash'
import { ModelApi } from '@wiz-api/material-management'
import { ThreeDimensionsApi } from '@wiz-api/guang-xi-shi-hua'
import { convertToNode, matchNodes, matchImg, nodesUV, batchNodesUV } from './js/publicModelMays'

const modelApi = new ModelApi()
const threeDimensionsApi = new ThreeDimensionsApi()
export default {
  components: {},
  props: {
    player: {
      type: Object,
      default: () => {
        return {}
      },
    },
    deviceInfo: {
      type: Object,
      defalut: () => {
        return {
          deviceName: null,
          deviceId: null,
          modelId: null,
        }
      },
    },
    currentNode: {
      type: Number,
      defalut: null,
    },
  },
  data() {
    return {
      isRootModel: false, // 是否是根模型
      deviceTreeLoading: false,
      allFlowDisabled: true,
      allFlowStatus: false, // 批量流向动画展示
      currentDeviceNode: null, // 当前装置node
      curRootItem: null,
      transparency: (60 / 255) * 100,
      currentDeviceId: null, // 当前装置id
      currentModelId: null, // 当前的模型id
      treeFilterKey: null,
      defaultTreeProps: {
        children: 'children',
        label: 'deviceName',
      },
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      searchData: {
        deviceName: null,
        tagCode: null,
        medium: null,
      },
      modelDetail: {
        filePath: '',
        materialFileId: '',
        modelFileId: '',
      },
      tableData: [],
      mediumList: [],
      treeData: [], // 装置treeData
      deviceList: [], // 装置列
      currentPipeActions: [], // 当前已经创建的动画
    }
  },
  computed: {
    // 模型相关设置
    modelSetting() {
      return (
        Wiz.globalSettings.globalConfig?.modelSetting ||
        _.get(Wiz, 'globalSettings.dynamicModules.modules["visualization-cockpit"].config')
          ?.modelSetting ||
        {}
      )
    },
    // 广西石化全场模型名称
    gxTexture() {
      return Wiz.globalSettings.globalConfig?.gxTexture || []
    },
  },
  watch: {
    treeFilterKey(val) {
      this.$refs.smallTreeDom.filter(val)
    },
  },
  async beforeDestroy() {
    // 上一个装置存在，隐藏节点，销毁动效
    if (this.currentPipeActions.length) {
      await this.stopEffect('all')
    }
    await this.destroyNode()
    const rootInfo = await this.player.Native.ModelTree.getRootItems()
    if (rootInfo?.length && rootInfo[0].item) {
      await this.player.Native.ModelTree.setItemVisible([rootInfo[0].item], true)
      await this.player.Native.ModelTree.setItemAlpha(rootInfo[0].item, 255)
    }
  },
  async created() {
    // 介质
    this.getMediumList()
    // 获取装置树
    this.getDeviceList()
  },
  methods: {
    // 透明度修改
    async transChange(val) {
      if (!this.isRootModel) {
        // 不是根模型即可调整
        this.$emit('loadingSwitch', { bol: true, title: '透明度调整中' })
        try {
          // 获取根节点
          const rootInfo = await this.player.Native.ModelTree.getRootItems()
          if (rootInfo?.length && rootInfo[0].item) {
            // 恢复模型状态
            await this.player.Native.ModelTree.setItemAlpha(
              rootInfo[0].item,
              Math.round((this.transparency / 100) * 255)
            )
          }
          this.$emit('loadingSwitch', { bol: false, title: '透明度调整中' })
        } catch (error) {
          console.error('---> error', error)
          this.$emit('loadingSwitch', { bol: false, title: '透明度调整中' })
        }
      }
    },
    // 滑块format
    tooltipFormat(val) {
      return (val / 100).toFixed(1)
    },
    // 通过key获取介质名称
    getMediumName(key) {
      const index = _.findIndex(this.mediumList, ['key', key])
      if (index > -1) {
        return this.mediumList[index].value
      }
      return ''
    },
    // 装置树检索
    filterTreeNode(value, data) {
      if (!value) return true
      return data.deviceName.indexOf(value) !== -1
    },
    // 装置树选择
    treeSelect(data) {
      if (!data.modelId) {
        this.$message.warning('该装置未绑定模型')
        return
      }
      if (this.currentDeviceId === data.id) {
        console.log('same device')
        return
      }
      this.$emit('loadingSwitch', { bol: true, title: '正在切换装置' })
      this.player.Native.Model.EventProgressEnd.connect(this.checkModelLoadEnd)
      this.searchData.deviceName = data.deviceName
      this.currentDeviceId = data.id
      this.currentModelId = data.modelId
      this.isRootModel = data.id === this.treeData[0].id // 判断是否是根模型
      this.$emit('updateDeviceInfo', {
        deviceName: data.deviceName,
        deviceId: data.id,
        modelId: data.modelId,
      })
      this.$refs.fatherNode.blur()
      this.resetDataAndDestroyNode()
      this.getModelDetail() // 获取模型详情
      this.searchHandler() // 获取管线列表
    },
    // 监听模型切换加载完成操作
    async checkModelLoadEnd(value, handle, name) {
      this.$emit('loadingSwitch', { bol: false, title: '正在切换装置' })
      if (this.isRootModel) {
        const rootInfo = await this.player.Native.ModelTree.getRootItems()
        if (rootInfo?.length && rootInfo[0].item) {
          this.curRootItem = rootInfo[0].item
        }
      } else {
        // 不是根模型进行初始化
        this.initDevice(this.modelDetail)
      }
      this.player.Native.Model.EventProgressEnd.disconnect(this.checkModelLoadEnd)
    },
    // 重置数据，销毁创建的node
    async resetDataAndDestroyNode() {
      this.currentPipeActions = [] // 清空动画列表
      this.currentSelectedPipe = [] // 清空多选
      this.tableData = [] // 清空表单
      this.searchData = Object.assign(this.searchData, {
        tagCode: null,
        medium: null,
      })
      await this.destroyNode()
    },
    // 获取模型详情信息
    async getModelDetail(first = false) {
      const [err, res] = await modelApi.get(this.currentModelId)
      if (!err && res?.medias) {
        const modelInfo = _.find(res.medias, ['mediaType', 1])
        const textureInfo = _.find(res.medias, ['mediaType', 2])
        if (modelInfo?.fileInfoId) {
          const modelDetail = {
            filePath: `data://../apps/${this.modelSetting.folderName}/models/${modelInfo.fileInfoId}/${modelInfo.fileInfoId}.pr`,
            materialFileId: textureInfo ? textureInfo.fileInfoId : '',
            modelFileId: modelInfo.fileInfoId,
          }
          this.modelDetail = modelDetail
          if (first) {
            this.initDevice(modelDetail)
          }
          this.$emit('changeModel', modelDetail)
        } else {
          this.$message.warning('模型文件不存在')
        }
      }
    },
    // 表格多选
    handleSelectionChange(val) {
      this.currentSelectedPipe = val
      this.resetSwitchStatus()
    },
    // 全量修改动效状态
    async changeAllStatus(val) {
      if (val) {
        this.$emit('loadingSwitch', { bol: true, title: '动画加载中' })
        try {
          this.player.Native.Camera.moveToCode(this.currentSelectedPipe[0].tagCode, 2)
          // 打开动画
          const needOpenPipes = filter(this.currentSelectedPipe, ['status', false])
          if (needOpenPipes?.length) {
            const flatTreeData = await this.player.Native.NodeProxy.getNodeChildrenRecursion(
              this.currentDeviceNode
            )
            const mixerList = []
            const nodeList = await this.filterNodeList(flatTreeData, needOpenPipes)
            for (let i = 0; i < nodeList.length; i += 1) {
              mixerList.push(
                // eslint-disable-next-line no-await-in-loop
                await nodesUV(
                  this.player,
                  { nodePtr: nodeList[i].nodePtr },
                  nodeList[i].materialType,
                  nodeList[i].direction,
                  nodeList[i].code
                )
              )
            }
            await Promise.all(mixerList)
            // 配置好贴图设置该node节点可见,node对应item隐藏
            const showNodeParams = map(nodeList, (item) => {
              return {
                node: item.nodePtr,
                visible: true,
              }
            })
            await this.player.Native.NodeProxy.batchSetNodeVisible(showNodeParams)
            const itemAsync = []
            for (let k = 0; k < nodeList.length; k += 1) {
              // eslint-disable-next-line no-await-in-loop
              const itemInfo = await this.player.Native.ModelTree.findItemByCode(
                nodeList[k].code,
                this.curRootItem
              )
              itemAsync.push(itemInfo)
            }
            await Promise.all(itemAsync)
            const itemList = map(itemAsync, 'item')
            await this.player.Native.ModelTree.setItemVisible(itemList, false)
            for (let j = 0; j < nodeList.length; j += 1) {
              this.currentPipeActions.push({
                mixer: mixerList[j],
                code: nodeList[j].code,
                node: nodeList[j].nodePtr,
                item: itemAsync[j].item,
              })
            }
            // 同步更新对应操作列开关状态
            const codeList = map(needOpenPipes, 'tagCode')
            forEach(this.tableData, (item) => {
              if (codeList.includes(item.tagCode)) {
                item.status = true
              }
            })
          }
          this.$emit('loadingSwitch', { bol: false, title: '动画加载中' })
        } catch (error) {
          this.$message.error(`创建动画出错了  ${error}`)
          this.$emit('loadingSwitch', { bol: false, title: '动画加载中' })
        }
      } else {
        // 关闭动画
        const needClosePipes = filter(this.currentSelectedPipe, ['status', true])
        const needCloseCodes = []
        const needSwitchStatus = []
        const asyncFunc = []
        for (let i = 0; i < needClosePipes.length; i += 1) {
          const actionIndex = findIndex(this.currentPipeActions, [
            'code',
            needClosePipes[i].tagCode,
          ])
          if (actionIndex > -1) {
            // eslint-disable-next-line no-await-in-loop
            asyncFunc.push(await this.stopEffect(this.currentPipeActions[actionIndex].mixer))
            needSwitchStatus.push(this.currentPipeActions[actionIndex])
            needCloseCodes.push(needClosePipes[i].tagCode)
          }
        }
        await Promise.all(asyncFunc)
        const hideNodeParams = map(needSwitchStatus, (item) => {
          return {
            node: item.node,
            visible: false,
          }
        })
        const showItemList = map(needSwitchStatus, 'item')
        // 显示item，隐藏带贴图的node
        await this.player.Native.NodeProxy.batchSetNodeVisible(hideNodeParams)
        await this.player.Native.ModelTree.setItemVisible(showItemList, true)
        this.currentPipeActions = filter(this.currentPipeActions, (item) => {
          return !needCloseCodes.includes(item.code)
        })
        forEach(this.tableData, (item) => {
          if (needCloseCodes.includes(item.tagCode)) {
            item.status = false
          }
        })
      }
    },
    /**
     * @description 批量整理node信息
     * @param {Array} flatTreeData 当前装置转换的node所有节点信息
     * @param {Array} needOpenPipes 当前选中，需要添加动效的所有管线数据
     */
    filterNodeList(flatTreeData, needOpenPipes) {
      let res = []
      const temp = map(needOpenPipes, (item) => {
        const direction = !!(item.direction === '正')
        let materialType = 'trueWhile'
        const materialIndex = findIndex(this.gxTexture, ['medium', item.mediumPhase])
        if (materialIndex > -1) {
          materialType = this.gxTexture[materialIndex].name
        }
        const index = findIndex(flatTreeData, ['name', item.tagCode])
        if (index > -1) {
          return {
            code: item.tagCode,
            nodePtr: flatTreeData[index].nodePtr,
            direction,
            materialType,
          }
        }
        return {}
      })
      res = filter(temp, (item) => {
        return !isEmpty(item)
      })
      return res
    },
    // 获取装置下拉列表
    async getDeviceList() {
      this.deviceTreeLoading = true
      const [err, res] = await threeDimensionsApi.getDeviceList({
        isTree: true,
        body: {
          name: null,
        },
      })
      this.deviceTreeLoading = false
      if (!err && res) {
        const filterTree = (nodes) => {
          const filterNode = (node) => {
            if (!node.modelId) {
              return null
            }
            if (node.children && node.children.length > 0) {
              const filteredChildren = node.children.map(filterNode).filter((child) => {
                return child !== null
              })
              node.children = filteredChildren.length > 0 ? filteredChildren : []
            }

            return node
          }
          return nodes.map(filterNode).filter((node) => {
            return node !== null
          })
        }
        this.treeData = filterTree(res)
        if (res.length) {
          if (this.deviceInfo.deviceId) {
            this.searchData.deviceName = this.deviceInfo.deviceName
            this.currentDeviceId = this.deviceInfo.deviceId
            this.currentModelId = this.deviceInfo.modelId
            this.isRootModel = this.deviceInfo.deviceId === res[0].id
          } else {
            this.searchData.deviceName = res[0].deviceName
            this.currentDeviceId = res[0].id
            this.currentModelId = res[0].modelId
            this.isRootModel = true
          }
          this.searchData = Object.assign(this.searchData, {
            tagCode: null,
            medium: null,
          })
          if (!this.isRootModel) {
            // 如果刚打开弹窗，当前模型不是根模型才进行初始化
            await this.getModelDetail(true)
          } else {
            // 刚打开弹窗，是根模型，更新数据
            const rootInfo = await this.player.Native.ModelTree.getRootItems()
            if (rootInfo?.length && rootInfo[0].item) {
              this.curRootItem = rootInfo[0].item
            }
          }
          // await this.initDevice() // 初始化装置
          this.searchHandler() // 获取全场管线数据
        }
      }
    },
    // 初始化装置状态，
    async initDevice(modelDetail) {
      this.$emit('loadingSwitch', { bol: true, title: '正在初始化装置' })
      try {
        const sceneRootNode = await this.player.Native.NodeProxy.rootNode()
        const modelNode = await this.player.Native.NodeProxy.loadModelNode(
          sceneRootNode,
          modelDetail.filePath,
          modelDetail.modelFileId
        )
        this.currentDeviceNode = modelNode
        const rootInfo = await this.player.Native.ModelTree.getRootItems()
        if (rootInfo?.length && rootInfo[0].item) {
          this.curRootItem = rootInfo[0].item
          // 设置创建的node不可见,原模型半透明
          await this.player.Native.NodeProxy.setNodeVisible(modelNode, false)
          await this.player.Native.ModelTree.setItemAlpha(
            rootInfo[0].item,
            Math.round((this.transparency / 100) * 255)
          )
        }
        this.$emit('loadingSwitch', { bol: false, title: '正在切换装置' })
      } catch (e) {
        this.$emit('loadingSwitch', { bol: false, title: '正在切换装置' })
      }
    },
    // 获取介质列表
    async getMediumList() {
      const [err, res] = await threeDimensionsApi.getSysDatat({
        parentKey: 'Medium',
      })
      if (!err && res?.code && res.code === '200' && res.data) {
        this.mediumList = res.data
      }
    },
    // 获取管线表数据
    async getTableData() {
      const [err, res] = await threeDimensionsApi.getDeviceRelationPipeLineList({
        body: {
          pageNo: this.page.pageNo,
          pageSize: this.page.pageSize,
          deviceId: this.currentDeviceId,
          tagCode: this.searchData.tagCode ? `%${this.searchData.tagCode}%` : null,
          medium: this.searchData.medium,
        },
      })
      if (!err && res?.code && res.code === '200' && res.data?.items) {
        this.tableData = res.data.items
        this.page.total = res.data.totalCount
      }
      forEach(this.tableData, (item) => {
        const index = findIndex(this.currentPipeActions, ['code', item.tagCode])
        if (index > -1) {
          this.$set(item, 'status', true)
        } else {
          this.$set(item, 'status', false)
        }
      })
    },
    // 管线状态修改
    async changeStatus(row) {
      if (row.status) {
        this.$emit('loadingSwitch', { bol: true, title: '动画加载中' })
        try {
          this.player.Native.Camera.moveToCode(row.tagCode, 2)
          // 开启流向
          let materialType = 'trueWhile'
          // 获取当前节点的全部子节点列表
          const flatTreeData = await this.player.Native.NodeProxy.getNodeChildrenRecursion(
            this.currentDeviceNode
          )
          const flowPipeObj = await matchNodes(flatTreeData, row.tagCode)
          if (!isEmpty(flowPipeObj)) {
            // 有此管线节点
            const direction = !!(row.direction === '正')
            const materialIndex = findIndex(this.gxTexture, ['medium', row.mediumPhase])
            if (materialIndex > -1) {
              materialType = this.gxTexture[materialIndex].name
            }
            // 添加贴图，并配置动画
            const mixer = await nodesUV(
              this.player,
              flowPipeObj,
              materialType,
              direction,
              row.tagCode
            )
            // 配置好贴图设置该node节点可见,node对应item隐藏
            this.player.Native.NodeProxy.setNodeVisible(flowPipeObj.nodePtr, true)
            const itemInfo = await this.player.Native.ModelTree.findItemByCode(
              row.tagCode,
              this.curRootItem
            )
            let tempItem = null
            if (itemInfo?.item) {
              tempItem = itemInfo.item
              this.player.Native.ModelTree.setItemVisible([itemInfo.item], false)
            }
            this.currentPipeActions.push({
              mixer,
              code: row.tagCode,
              node: flowPipeObj.nodePtr,
              item: tempItem,
            })
          } else {
            // 无此管线节点
            this.$message.error('当前装置无此管线')
          }
          this.resetSwitchStatus()
          this.$emit('loadingSwitch', { bol: false, title: '动画加载中' })
        } catch (error) {
          this.$message.error(`创建动画出错了  ${error}`)
          this.$emit('loadingSwitch', { bol: false, title: '动画加载中' })
        }
      } else {
        // 关闭流向
        const actionIndex = findIndex(this.currentPipeActions, ['code', row.tagCode])
        if (actionIndex > -1) {
          // 停止流向
          await this.stopEffect(this.currentPipeActions[actionIndex].mixer)
          // 恢复贴图
          // await this.player.Native.NodeProxy.setMaterialTexture(
          //   this.currentPipeActions[actionIndex].mat,
          //   this.currentPipeActions[actionIndex].initialTexture
          // )
          // 因贴图材质不好恢复，则直接停止动画，后隐藏带贴图node,显示原来的item
          await this.player.Native.ModelTree.setItemVisible(
            [this.currentPipeActions[actionIndex].item],
            true
          )
          await this.player.Native.NodeProxy.setNodeVisible(
            this.currentPipeActions[actionIndex].node,
            false
          )
          this.currentPipeActions.splice(actionIndex, 1)
        }
        this.resetSwitchStatus()
      }
    },
    // 当单个管线的按钮状态切换时，调整总体动画开关状态
    resetSwitchStatus() {
      if (this.currentSelectedPipe?.length) {
        this.allFlowDisabled = false
        const codeWithAnimation = map(this.currentPipeActions, (item) => {
          return item.code
        })
        let hasNoAnimationPipe = false
        // 判断多选项里是否有还未加载动画的管线
        try {
          forEach(this.currentSelectedPipe, (item) => {
            if (!codeWithAnimation.includes(item.tagCode)) {
              hasNoAnimationPipe = true
              throw new Error()
            }
          })
          // eslint-disable-next-line no-empty
        } catch (e) {}
        if (hasNoAnimationPipe) {
          // 有未创建动画的管线、将状态改为false
          this.allFlowStatus = false
        } else {
          // 无未创建的动画，则按钮为true，可执行关闭操作
          this.allFlowStatus = true
        }
      } else {
        this.allFlowDisabled = true
      }
    },
    // 搜索
    searchHandler() {
      this.page.pageNo = 1
      this.getTableData()
    },
    moveToPipe(row) {
      if (row.tagCode) {
        this.player.Native.Camera.moveToCode(row.tagCode, 2)
      }
    },
    // 销毁装置node
    async destroyNode() {
      if (this.currentDeviceNode) {
        await this.player.Native.NodeProxy.destroyNode(this.currentDeviceNode)
        this.currentDeviceNode = null
      }
    },
    // 流向动画去除
    async stopEffect(target) {
      if (target === 'all') {
        // 切换装置，全量去除
        const asyncFunc = []
        for (let i = 0; i < this.currentPipeActions.length; i += 1) {
          asyncFunc.push(
            // eslint-disable-next-line no-await-in-loop
            await this.player.Native.AnimationClip.clearClip(this.currentPipeActions[i].mixer)
          )
        }
        await Promise.all(asyncFunc)
        this.currentPipeActions = []
      } else {
        // 单个去除
        await this.player.Native.AnimationClip.clearClip(target)
      }
    },
  },
}
</script>
<style lang="scss">
.visualization-select-popper {
  .el-select-dropdown__list {
    padding: 5px !important;
  }
}
</style>
<style lang="scss" scoped>
.search-wrap {
  ::v-deep .el-button {
    height: 28px !important;
    line-height: 28px !important;
    border-radius: 5px !important;
  }
}
.markerTable {
  ::v-deep .el-checkbox {
    margin: 0 !important;
  }
  ::v-deep .el-table th.is-leaf,
  .el-table td {
    border: none !important;
  }
}
::v-deep.device-tree {
  overflow-y: auto;
  height: 100%;
  color: #fff;
  background-color: transparent !important;

  .el-tree-node__content:hover {
    background: #0499a744 !important;
  }

  .el-tree-node.is-current > .el-tree-node__content {
    background: #049aa780 !important;
  }

  .el-tree-node:focus > .el-tree-node__content {
    background: #049aa780 !important;
  }
  .el-tree-node__label {
    color: #fff !important;
  }

  .custom-tree-node {
    width: 100%;
    font-size: 14px;
  }
}
.pipe-flow-analysis {
  ::v-deep .el-slider__bar {
    background: #11939d !important;
  }
  ::v-deep .el-slider__button {
    width: 10px !important;
    height: 10px !important;
    border: 2px solid #11939d !important;
  }
}
::v-deep {
  .el-pagination.is-background.el-pagination--small .btn-next,
  .el-pagination.is-background.el-pagination--small .btn-prev,
  .el-pagination.is-background.el-pagination--small .el-pager li {
    padding: 0 !important;
    margin: 0 3px !important;
  }
}
</style>
